import React from 'react';

import { identity } from "../../utils/getIdentity";
import { useTranslation } from "react-i18next";

const NotificationBlock = ({ item }) => {
  const { t } = useTranslation();

  const transactionStatus = {
    "Done": t('done'),
    "Waiting for funds": t('waiting_for_funds'),
    "Error": t('error')
  };

  const transactionType = {
    "Refund": t('refunds'),
    "Replenishment": t('replenishment'),
    "SystemFee": t('systemFee')
  };

  const transactionDescription = {
    "Transaction Refund: status Done": t('transactionStatus.refundDone'),
    "Transaction Refund: status New": t('transactionStatus.refundNew'),
    "Transaction Replenishment: status Waiting for funds": t('transactionStatus.replenishmentWaiting'),
    "Transaction SystemFee: status Done": t('transactionStatus.systemFeeDone'),
    "Transaction SystemFee: status Error": t('transactionStatus.systemFeeError')
  }

  return (
    <div className="notification-block">
      <div className={`notification-block__line notification-block__line-${item?.transaction?.status.toLowerCase()}`}></div>
      <div className="notification-block__wrapper">
        <div className="notification-block__top">
          <div>
            <div className={`notification-block__title notification-block__title-${identity}`}>{transactionType[item?.transaction?.type]}</div>
            <div className={`notification-block__token notification-block__token-${identity}`}>{item?.currency}</div>
          </div>
          <div className={`notification-block__status notification-block__status-${item?.transaction?.status.toLowerCase().replace(/\s+/g, '_')} notification-block__status-${item?.transaction?.status.toLowerCase().replace(/\s+/g, '_')}-${identity}`}>{transactionStatus[item?.transaction?.status]}</div>
        </div>
        <div className={`notification-block__error notification-block__error-${identity}`}>{transactionDescription[item?.message]}</div>
        {item?.transaction?.status === 'Done' && (
          <div className={`notification-block__description notification-block__description-${identity}`}>
            {t('notification.success')}
          </div>
        )}
      </div>
    </div>
  )
};

export default NotificationBlock;
